import request from "../api/request";
import utils from "../../utils/index";
import pfile from "@/utils/secretkey/pfile";
import sfile from "@/utils/secretkey/sfile";

var ak = utils.genak();
var ed = utils.re(ak, unescape(pfile)); //秘钥

function decrypt(data){
  if (data?.ak){
    let plaintext = utils.rd(data.ak, unescape(sfile));
    let obj = utils.secret(data.ed, plaintext, true);
    return JSON.parse(obj);
  }else{
    return data
  }
}

function inParameter(data){
  if (data){
    return { sn: ed, jt: utils.secret(data, ak)}
  }else{
    return data
  }
}

export function userMsg(data) {
  return request({
    url: "/msg-service/userMsg/detailsList",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}
export function userMsgread(data) {
  return request({
    url: "/msg-service/userMsg/read",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}
export function userMsginfoapi(data) {
  return request({
    url: "/msg-service/userMsg/info",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// web首页动态列表
export function webHome(data) {
  return request({
    url: "/user-service/home/webHome",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// 获取动态设置
export function appDynamicsSwitch(data) {
  return request({
    url: "/user-service/home/appDynamicsSwitch",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// 修改动态设置
export function appDynamicsSwitchUpdate(data) {
  return request({
    url: "/user-service/home/appDynamicsSwitchUpdate",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// 动态详情接口
export function getDynamicDetails(data) {
  return request({
    url: "/user-service/home/getDynamicDetails",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// 查询文件夹路径
export function checkFolder(data) {
  return request({
    url: "/user-service/home/checkFolder",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}


